// Importing React and external libs
import React, { useState, useEffect } from 'react';

// Importing helix hooks
import useLanguage from 'helix-hooks/language';

// Importing component languages
import languages from '../lng';

// Importing CSS
import './style.scss';

// Constants
const MAX_FAILED_ATTEMPTS = 3;

const LockoutCountdown = ({ loginAttemptResponse = {}, maxFailedAttempts = MAX_FAILED_ATTEMPTS, onCountdownEnd }) => {
  const Language = useLanguage({ languages });
  const [countdown, setCountdown] = useState(0);
  const [isLocked, setIsUserLocked] = useState(!!loginAttemptResponse?.['is_locked']);

  useEffect(() => {
    if (loginAttemptResponse?.['is_locked']) {
      const coolOffTime = loginAttemptResponse?.['cool_off_time_remaining'] || '00:00:00';
      const [hours, minutes, seconds] = coolOffTime
        .split(':')
        .map(part => parseInt(part, 10) || 0);

      const totalSeconds = hours * 3600 + minutes * 60 + seconds;

      setIsUserLocked(true);
      setCountdown(totalSeconds);
    }
  }, [loginAttemptResponse]);

  useEffect(() => {
    if (countdown === 0 || !isLocked) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);

          if (typeof onCountdownEnd === 'function') {
            onCountdownEnd();
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [countdown, isLocked, onCountdownEnd]);

  const formatTime = (totalSeconds) => {
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  if (!isLocked || countdown <= 0) return null;

  return (
    <div className="countdown-timer">
      {Language.get('login', 'USER_LOCKOUT_COUNTDOWN')
        .replace('$countdown', formatTime(countdown))
        .replace('$failedAttempts', maxFailedAttempts)
      }
    </div>
  );
};

export default LockoutCountdown;
